import { ModalWindow } from '@cian/ui-kit';
import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useMobileFilters } from 'shared/hooks/useMobileFilters';
import { selectMobileFiltersVisible } from 'shared/selectors/page/selectMobileFiltersVisible';
import { MyHomeFormContainer } from '../../MyHomeFormMicrofrontend';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const FiltersMobileContainer: React.FC = () => {
  const { closeMobileFiltersModal } = useMobileFilters();
  const mobileFiltersVisible = useSelector(selectMobileFiltersVisible);
  const { logger } = useApplicationContext();

  return (
    <ModalWindow
      open={mobileFiltersVisible}
      onClose={closeMobileFiltersModal}
      title="Добавить объект в Мой дом"
      content={
        <ErrorLogComponent logger={logger} errorStub={<></>}>
          <MyHomeFormContainer />
        </ErrorLogComponent>
      }
      width="100%"
      height="100%"
    />
  );
};

FiltersMobileContainer.displayName = 'FiltersMobileContainer';
